import {Collapse} from '@components/Collapse';
import {Component} from 'lowkey-component';

export class Accordion extends Component {
  private collapses: Collapse[] = [];

  didMount() {
    const nodes = [
      ...(this.element?.querySelectorAll?.(
        '.js-collapse',
      ) as NodeListOf<HTMLDivElement>),
    ];

    nodes?.map((node) => {
      const collapse = new Collapse(node);
      collapse.mount();
      this.collapses.push(collapse);
    });

    this.collapses.map((collapse) => {
      collapse.clearHandle();

      collapse.trigger?.on('click', () => {
        this.collapses.map((col) => {
          if (collapse.element != col.element) {
            col.slideUp();
          }
          if (collapse.element == col.element) {
            col.isOpen ? col.slideUp() : col.slideDown();
            // col.isOpen && col.slideUp();
          }
        });
      });
    });
  }
}
